module.exports = __webpack_public_path__ + "img/xiaohe2.61475913.png";